import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import { Protect } from "../../../routes/cryptography";
import FileDownload from "js-file-download";
import { Buffer } from "buffer"

//const feedback = "Ты сделал это!";

class ProtectView extends Component {
  constructor() {
    super();
    this.state = {
      dataProtect: {
        data: "",
        alg: "belt-ctr256",
        dataPrivKey: "",
        password: "",
        dataPubKey: "",
      },
      pubkeyFileName: "файл",
      pubkeyFileIsOpen: false,
      isValidPrivKeyFileSize: true,
      isValidPubKeyFileSize: true,
      privkeyFileName: "файл",
      privkeyFileIsOpen: false,
      errors: {},
    };
    ///////VerifySign Func////
    this.handleInputChangedataProtect = this.handleInputChangedataProtect.bind(
      this
    );
    this.handleSelectChange = this.handleSelectChange.bind(this);
    // this.handleFileForEncryptChange = this.handleFileForEncryptChange.bind(
    //   this
    // );
    this.handlePubKeyChange = this.handlePubKeyChange.bind(this);

    this.handleInputPassChange = this.handleInputPassChange.bind(this);
    this.handlePrivKeyChange = this.handlePrivKeyChange.bind(this);
    this.handleEncryptSubmit = this.handleEncryptSubmit.bind(this);
  }

  componentDidMount() { }
  handleSelectChange(e) {
    try {
      //console.log(e.target.value);
      this.setState({
        dataProtect: { ...this.state.dataProtect, alg: e.target.value },
      });
    } catch (error) {
      //console.log(error);
    }
  }

  handleInputPassChange(e) {
    //console.log(e.target.value);
    try {
      this.setState({
        dataProtect: { ...this.state.dataProtect, password: e.target.value },
      });

      ////console.log(e.target.value);
    } catch (error) {
      //console.log(error);
    }
  }
  handleInputChangedataProtect(e) {
    //console.log(e.target.value);
    try {
      this.setState({
        dataPubKeyFileName: "файл",
        dataPubKeyFileIsOpen: false,
        // signFileName: "файл",
        // signFileIsOpen: false,
        // certFileName: "файл",
        // certFileIsOpen: false,

        dataProtect: {
          ...this.state.dataProtect,
          data: btoa(unescape(encodeURIComponent(e.target.value))),
        },
      });
      //console.log(e.target.value.length);

      // //console.log(e.target.value);
    } catch (error) {
      //console.log(error);
    }
  }

  // handleFileForEncryptChange() {
  //   try {
  //     const file = document.getElementById("dataForEncrypt").files[0];
  //     //console.log(file);

  //     if (file !== undefined) {
  //       document.getElementById("inputdataProtect").disabled = true;
  //       this.setState({
  //         dataPubKeyFileName: file.name,
  //         dataPubKeyFileIsOpen: true,
  //       });
  //       var reader = new FileReader();
  //       reader.readAsArrayBuffer(file);
  //       reader.onload = () => {
  //         const buffer = reader.result;

  //         const data = new Buffer(new Uint8Array(buffer)).toString("base64");

  //         this.setState({
  //           dataProtect: { ...this.state.dataProtect, data: data },
  //         });
  //         //console.log(data);
  //       };
  //       reader.onerror = (e) => {
  //         console.error(e);
  //       };
  //     } else {
  //       document.getElementById("inputdataProtect").disabled = false;

  //       this.setState({
  //         dataPubKeyFileName: "файл",
  //         dataPubKeyFileIsOpen: false,
  //       });
  //     }
  //   } catch (error) {
  //     //console.log(error);
  //   }
  // }

  handlePubKeyChange() {
    try {
      const file = document.getElementById("filePubkey").files[0];
      //console.log(file);

      if (file !== undefined && file.size < 20000000) {
        this.setState({ pubkeyFileName: file.name, pubkeyFileIsOpen: true, isValidPubKeyFileSize: true });
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;

          const data = new Buffer(new Uint8Array(buffer)).toString("base64");

          this.setState({
            dataProtect: { ...this.state.dataProtect, dataPubKey: data },
          });
          //console.log(data);
        };
        reader.onerror = (e) => {
          console.error(e);
        };
      } else {
        this.setState({ pubkeyFileName: "файл", pubkeyFileIsOpen: false, isValidPubKeyFileSize: false });
      }
    } catch (error) {
      //console.log(error);
    }
  }

  handlePrivKeyChange() {
    try {
      const file = document.getElementById("filePrivkey").files[0];
      //console.log(file);

      if (file !== undefined && file.size < 20000000) {
        this.setState({ privkeyFileName: file.name, privkeyFileIsOpen: true, isValidPrivKeyFileSize: true });
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;

          const data = new Buffer(new Uint8Array(buffer)).toString("base64");

          this.setState({
            dataProtect: { ...this.state.dataProtect, dataPrivKey: data },
          });
          //console.log(data);
        };
        reader.onerror = (e) => {
          console.error(e);
        };
      } else {
        this.setState({ privkeyFileName: "файл", privkeyFileIsOpen: false, isValidPrivKeyFileSize: false });
      }
    } catch (error) {
      //console.log(error);
    }
  }

  handleEncryptSubmit(e) {
    e.preventDefault();
    try {
      //console.log(`Данные: ${this.state.dataProtect.data}`);
      //console.log(`алгоритм: ${this.state.dataProtect.alg}`);
      //console.log(`ключ: ${this.state.dataProtect.dataPubKey}`);
      Protect(
        btoa(unescape(encodeURIComponent(this.state.dataProtect.alg))),
        this.state.dataProtect.data,
        this.state.dataProtect.dataPrivKey,
        btoa(unescape(encodeURIComponent(this.state.dataProtect.password))),
        this.state.dataProtect.dataPubKey
      ).then((res) => {
        //console.log(res);
        if (res.status === 200) {
          FileDownload(res.data.data, "encryptData.pem");
          FileDownload(res.data.sign, "sign.pem");
          FileDownload(res.data.token, "token.pem");

          document.getElementById("view").style.borderColor = "green";
        } else {
          document.getElementById("view").style.borderColor = "red";
        }
      });
    } catch (error) {
      document.getElementById("view").style.borderColor = "red";

      //console.log(error);
    }
  }

  render() {
    return (
      <div className="container">
        <h6 className="major">{this.props.encryptType}</h6>
        <Form onSubmit={this.handleEncryptSubmit}>
          <div className="sm-4">
            <Form.Group>
              <Form.Label>Введите текст</Form.Label>
              <Form.Control
                id="inputdataProtect"
                onChange={this.handleInputChangedataProtect}
                as="textarea"
                aria-label="With textarea"
                style={{ color: "black" }}
              />
            </Form.Group>

            {/* <Form.Label style={{ marginLeft: "50%" }}>или</Form.Label>

            <Form.Group
              style={{ paddingBottom: "20px", borderBottom: "1px solid white" }}
            >
              <Form.Label>Выберите файл </Form.Label>
              <Form.File custom>
                <Form.File.Input
                  id="dataForEncrypt"
                  onChange={this.handleFileForEncryptChange}
                  isValid={this.state.dataPubKeyFileIsOpen}
                  disabled
                />
                <Form.File.Label data-browse="Выбрать">
                  {this.state.dataPubKeyFileName}
                </Form.File.Label>
                <Form.Control.Feedback type="valid" />
              </Form.File>
            </Form.Group> */}
            <Form.Group>
              <Form.Label>Алгоритм шифрования</Form.Label>
              <Form.Control
                onChange={this.handleSelectChange}
                defaultValue={this.state.dataProtect.alg}
                as="select"
                custom
              >
                <option>belt-ctr256</option>
                <option>belt-ecb256</option>
                <option>belt-cbc256</option>
                <option>belt-cfb256</option>
              </Form.Control>
            </Form.Group>
            <Form.Group>
              <Form.Label>Выберите файл личного ключа</Form.Label>
              <Form.File custom>
                <Form.File.Input
                  id="filePrivkey"
                  onChange={this.handlePrivKeyChange}
                  isValid={this.state.privkeyFileIsOpen}
                  isInvalid={!this.state.isValidPrivKeyFileSize}

                  required
                />
                <Form.File.Label data-browse="Выбрать">
                  {this.state.privkeyFileName}
                </Form.File.Label>
                <Form.Control.Feedback type="valid" />
                <Form.Control.Feedback type="invalid">
                  максимальный размер файла 20мб
                </Form.Control.Feedback>
              </Form.File>
            </Form.Group>
            <Form.Group>
              <Form.Label>Введите пароль личного ключа</Form.Label>
              <Form.Control
                type="password"
                placeholder="Пароль"
                onChange={this.handleInputPassChange}
                style={{ height: "2rem", color: 'white' }}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>
                Выберите файл открытого ключа или сертификат получателя
              </Form.Label>
              <Form.File custom>
                <Form.File.Input
                  id="filePubkey"
                  onChange={this.handlePubKeyChange}
                  isValid={this.state.pubkeyFileIsOpen}
                  isInvalid={!this.state.isValidPubKeyFileSize}

                  required
                />
                <Form.File.Label data-browse="Выбрать">
                  {this.state.pubkeyFileName}
                </Form.File.Label>
                <Form.Control.Feedback type="valid" />
                <Form.Control.Feedback type="invalid">
                  максимальный размер файла 20мб
                </Form.Control.Feedback>
              </Form.File>
            </Form.Group>
            {/* <Form.Label style={{ float: "left" }}>
              {this.state.dataSign.statusSign}
            </Form.Label> */}
            <Button
              style={{ float: "right" }}
              variant="success"
              type="submit"
              size="sm"
            >
              Зашифровать
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}
export default connect()(withRouter(ProtectView));
